// extracted by mini-css-extract-plugin
export var configurationSection = "_ti-0";